import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Typography } from 'antd'
import './SuccessScreen.css'
import successPic from '../../../assets/img/success_pic.png'
// import history from "../../../routes/history";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { wizardCompleted } from '../../../redux/actions';
import { setCookie } from '../../../shared/helpers';

export default function SuccessScreen() {

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const allset = true

  useEffect(() => {

    if (window.location.href.indexOf("/employer/allset") != -1) {

      window.gtag("event", "conversion", {

        send_to: "AW-972299611/i2AICPyYxZIYENu60M8D",

      });

    }

  }, []);

  return (
    <div className='success-mainContainer'>

      <div className={allset ? 'itemsContainerAllset' : 'itemsContainer'}>

        {allset ? <div className='allSetText'>
          <h1>Your Company Profile is All Set!</h1>
          <p className='text-para'>Great job! Your company profile is all set. You can always edit your company profile later.</p>
        </div> :
          <div className='heading'>
            Payment successful
          </div>}

        <img src={successPic} className={allset ? 'successScreen-pic-Allset' : "successScreen-pic"} />

        <Button className={allset ? 'successScreen-btn-Allset' : 'successScreen-btn'} onClick={() => {
          window.name = 'employerdashboard'
          setCookie('finishProfile', 'true');
          // localStorage.setItem('finishProfile', 'true')
          history.push('/employerdashboard')
        }}>
          {allset ? 'Go to dashboard' : 'Download receipt'}</Button>
        <div className='bottomText' onClick={() => {
          setCookie('finishProfile', 'true');
          history.push("/companyprofile")
        }
        }
          style={{ cursor: "pointer" }}
        >
          {allset ? 'Edit company profile' : 'Go back to spends'}</div>
      </div>
    </div>

  )
}

